import React, { useEffect, useState } from "react";
import { Link, Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { authService } from "../services/auth";
import { Button, EmptyState, Spinner } from "./ui";

export function RequireAuth({ children }) {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  if (!isLoggedIn) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  return children || <Outlet />;
}

/** ต้องเป็น super_user — ถาม Backend ทุกครั้งที่เข้า (ไม่เชื่อค่าใน localStorage) */
export function RequireSuperUser({ children }) {
  const { isLoggedIn } = useAuth();
  const location = useLocation();
  const [state, setState] = useState("checking");
  useEffect(() => {
    let alive = true;
    if (!isLoggedIn) return undefined;
    authService
      .verifySuperUser()
      .then((ok) => alive && setState(ok ? "ok" : "denied"))
      .catch(() => alive && setState("denied"));
    return () => {
      alive = false;
    };
  }, [isLoggedIn]);
  if (!isLoggedIn) return <Navigate to="/su" replace state={{ from: location.pathname }} />;
  if (state === "checking")
    return (
      <div className="page-center">
        <Spinner size={28} />
      </div>
    );
  if (state === "denied")
    return (
      <div className="page-center">
        <EmptyState icon="lock" title="ไม่มีสิทธิ์เข้าหน้านี้" action={<Link to="/chat"><Button variant="primary">กลับไปหน้าแชท</Button></Link>}>
          หน้านี้สำหรับผู้ดูแลระบบ (super_user) เท่านั้น
        </EmptyState>
      </div>
    );
  return children || <Outlet />;
}

/** หน้า login/register — ล็อกอินแล้วไม่ต้องเห็น */
export function GuestOnly({ children }) {
  const { isLoggedIn } = useAuth();
  if (isLoggedIn) return <Navigate to="/chat" replace />;
  return children || <Outlet />;
}
